import { X } from 'lucide-react';

interface ImagePreviewProps {
  imageUrl: string;
  onClear: () => void;
}

export function ImagePreview({ imageUrl, onClear }: ImagePreviewProps) {
  return (
    <div className="p-4 border-b border-brand-gold/10 bg-brand-smoke/30">
      <div className="relative inline-block">
        <img
          src={imageUrl}
          alt="Preview"
          className="max-h-32 rounded-lg"
        />
        <button
          onClick={onClear}
          className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-red-500 text-white flex items-center justify-center hover:bg-red-600 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
